import DataService from "features/Application/services/dataServices/typedDataService";
import backgroundTask from "features/BackgroundTasks/backgroundTask";

import { type AppDispatch, type AppThunk } from "features/Application/globaltypes/redux";
import { type DistributedOpUpdateParams } from "interfaces";
import { type PdfOverview } from "features/Library/Pdfs/types/state";
import { pluralize } from "utils/stringUtils";
import { fetchFailure, updatePdfBegin, updatePdfSuccess } from "../../slices/pdfOverviewSlice";

export const deletePdfs =
  (ids: number[], fetchPdfs: () => void): AppThunk =>
  async (dispatch: AppDispatch) => {
    const getOperationProps = async () => {
      const { data } = await DataService.pdfs.deletePdfsAsync(ids);
      return data;
    };

    const idsCount = ids.length;
    const entity = pluralize("PDF", idsCount);

    const updateParams: DistributedOpUpdateParams = {
      id: "DeletePdf",
      title: "Deletion of PDFs",
      onCompleted: () => fetchPdfs(),
      getOperationProps,
      successTransientMessage: `${entity} ${idsCount === 1 ? "has" : "have"} been deleted!`,
      failureTransientMessage: `${entity} delete failed!`,
    };

    await backgroundTask.initializeDistributedBackgroundTask(updateParams, dispatch);
  };

export const updatePdf = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(updatePdfBegin());
  try {
    const result = await DataService.pdfs.getPdfAsync(id);
    dispatch(updatePdfSuccess(result.data as unknown as PdfOverview));
  } catch (error) {
    dispatch(fetchFailure(error));
  }
};

export const changeVisibility =
  (ids: number[], visible: boolean, onCompleted: () => void): AppThunk =>
  async (dispatch: AppDispatch) => {
    const idsCount = ids.length;
    const entity = pluralize("PDF", idsCount);
    const asset = pluralize("Asset", idsCount);

    const updateParams: DistributedOpUpdateParams = {
      id: "VisibilityVideosDistributedOperation",
      title: `${visible ? "Showing" : "Hiding"} ${asset}`,
      onCompleted,
      getOperationProps: async () => {
        const { data } = await DataService.pdfs.changeVisibility(ids, visible);
        return data;
      },
      successTitle: `${entity} ${visible ? "Shown" : "Hidden"}!`,
      successTransientMessage: `${entity} ${idsCount === 1 ? "has" : "have"} been ${visible ? "shown" : "hidden"} successfully!`,
      failureTransientMessage: `${entity} ${visible ? "showing" : "hiding"} failed!`,
    };

    await backgroundTask.initializeDistributedBackgroundTask(updateParams, dispatch);
  };
